export interface CarbonCreditListing {
  id: number;
  seller: string;
  type: string;
  price: number;
  region: string;
  trend: 'up' | 'down';
}

const sampleListings: CarbonCreditListing[] = [
  { id: 1, seller: 'Green Farm Co', type: 'Soil Sequestration', price: 10, region: 'Nairobi', trend: 'up' },
  { id: 2, seller: 'Eco Logistics Ltd', type: 'Transportation Offset', price: 8, region: 'Mombasa', trend: 'down' },
  { id: 3, seller: 'Tree Planters', type: 'Reforestation', price: 12, region: 'Kisumu', trend: 'up' },
];

export const fetchCarbonCreditListings = async (): Promise<CarbonCreditListing[]> => {
  // In a real app this would fetch from a backend or external API
  return Promise.resolve(sampleListings);
};
